<script>
  export let status;
</script>

<style>
  .ots {
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    border-radius: 50%;
    padding: 2px 5px;
    border: 1px solid white;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.4);
  }
  .on-time {
    background: #61ce70;
    color: white;
  }
  .early {
    background: #e5cc2f;
    color: black;
  }
  .late {
    background: #e5902f;
    color: black;
  }
</style>

{#if status === 0}
  <div class="ots on-time">OT</div>
{:else if status === 2}
  <div class="ots early">ER</div>
{:else if status === 3}
  <div class="ots late">LT</div>
{/if}
